import { useEffect } from "react";
import { useLocation, withRouter } from "react-router-dom";

import { confirmEmail } from "../../../services/user.service";
import { error, success } from "../../../services/toast.service";

const ConfirmEmail = (props: any) => {
    const query = new URLSearchParams(useLocation().search);
    const confirmToken = query.get("confirm-token") as string;

    const sendConfirmationEmail = async () => {
        try {
            await confirmEmail(confirmToken);
            success("Email was successfully confirmed! You can now sign in.");
        } catch {
            error("This confirmation link is invalid or has expired.");
        }
        props.history.push("/sign-in");
    };

    useEffect(() => {
        sendConfirmationEmail();
    }, []);

    return null;
};

export default withRouter(ConfirmEmail);
